export default __webpack_public_path__ + "static/quickswap-9095566b56424ce556b16e0e56a9a778.png";